import React, {Component} from 'react'

import {Vector2} from 'utils/MathUtils.js'

import WaterSimulation from './WaterSimulation.js';



const DEG_TO_RAD = Math.PI / 180;
const RAD_TO_DEG = 180 / Math.PI;

const velocityBounceAttenuation = 0.8;
const fGravity = 600;
const cDrag = 0.002;
const cFRepulsion = 2000;
const cViscosity = 0.01;

const numBoundingBoxesX = 5;
const numBoundingBoxesY = 10;


class WaterSimulationContainer extends Component {
    constructor(props) {
        super(props);
        this.running = false;
        this.bounds = new Vector2(100, 100);
        this.timerId = null;
        this.canvas = null;
        this.context = null;
        this.onClick = this.onClick.bind(this);
        this.setCanvas = this.setCanvas.bind(this);
        this.onResizeWindow = this.onResizeWindow.bind(this);
        this.update = this.update.bind(this);

        this.init(); 

        this.cAF = (window.cancelAnimationFrame  || window.cancelRequestAnimationFrame).bind(window);
        this.rAF = (window.requestAnimationFrame || window.webkitRequestAnimationFrame).bind(window);
    }

    init() {
        this.particles = [];
        this.boundingBoxes = new Array(numBoundingBoxesX*numBoundingBoxesY);
        for(var i = 0; i < numBoundingBoxesX; i++) {
            for(var j = 0; j < numBoundingBoxesY; j++) {
                var r = Math.round(Math.random()*255);
                var g = Math.round(Math.random()*255);
                var b = Math.round(Math.random()*255);
                this.boundingBoxes[i + j*numBoundingBoxesX] = {color:'rgb('+r+','+g+','+b+')', members:[]};
            }
        }
    }

    addParticles() {
        const particleCount = 200;
        var particles = new Array(particleCount);

        var entryPoint = new Vector2(this.bounds.x/3, this.bounds.y/2);
        var entryPointWidth = this.bounds.x/5;
        var entryPointHeight = this.bounds.y/3;
        for (var i = 0; i < particleCount; i++) {
            var p = new Vector2(entryPoint.x + 2*(Math.random()-0.5)*entryPointWidth, 
                                entryPoint.y + 2*(Math.random()-0.5)*entryPointHeight);
            var v   = new Vector2(0, 0);
            var radius = 15;
            particles[i] = new Particle(p, v, radius, this);
        }
        this.particles = this.particles.concat(particles);
    }

    componentDidMount() {
        window.addEventListener('resize', this.onResizeWindow);
        this.componentMountedAt = new Date().getTime();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResizeWindow);
        this.stop()
        this.componentMountedAt = null;
    }

    onResizeWindow() {
        this.setBounds();
    }

    onClick() { 
        //this.particles = [];
        this.addParticles();
    }

    setCanvas(ref) {
        this.canvas = ref;
        if(this.canvas) {
            this.setBounds();
            this.start();
        }
    }

    setBounds() {
        if(this.canvas) {
            this.bounds.x      = this.canvas.offsetWidth;
            this.bounds.y      = this.canvas.offsetHeight;
            this.canvas.width  = this.canvas.offsetWidth;
            this.canvas.height = this.canvas.offsetHeight;
        }
    }

    update() {
        var t1 = Date.now();
        var t0 = this.lastFrameAt;
        var dt = Math.min((t1 - t0)/1000, 0.05);
        this.lastFrameAt = t1;
        this.context = this.canvas.getContext('2d');
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        for (var i = 0; i < this.particles.length; i++) {
            this.particles[i].reset();
        }
        for (var i = 0; i < this.particles.length; i++) {
            this.particles[i].update(dt, t1);
            this.particles[i].draw(this.context);
        }
        if(this.running) {
            this.timerId = this.rAF( this.update );
        }
    }

    start() {
        if(!this.running) {
            if(this.particles.length==0) {
                this.addParticles();
            }
            this.lastFrameAt = Date.now();
            this.running = true;
            this.update();
        }
    }
    stop() {
        console.log('WaterSimulation stopped');
        this.running = false;
        this.canvas = null;
        this.context= null;
        if(this.timerId) {
            this.cAF(this.timerId);
            this.timerId = null;
        }
    }


    render() {
        return <WaterSimulation {...this.props} 
                                setCanvas={this.setCanvas} 
                                onClick={this.onClick}/>
    }
}





class Particle {
    constructor(p, v, radius, world) {
        this.world = world;
        this.p = p; //position
        this.v = v; //velocity
        this.f = new Vector2(0, 0); //applied forces
        this.radius = radius;
        this.clipDistance = (2*this.radius);
        this.clipDistanceSquared = this.clipDistance*this.clipDistance;
        this.color = 'rgba(30,180,255,0.6)';
/*
        var r = Math.round(Math.random()*255);
        var g = Math.round(Math.random()*255);
        var b = Math.round(Math.random()*255);
        this.color = 'rgb('+r+','+g+','+b+')';
*/
        this.ibbx = null;
        this.ibby = null;
        this.ibb  = null;

        this.p0 = new Vector2(this.p.x, this.p.y);
        this.v0 = new Vector2(this.v.x, this.v.y);
    }

    reset() {
        this.f.x = 0;
        this.f.y = 0;
    }

    update(dt, t) {
        this.p0.set(this.p.x, this.p.y);
        this.v0.set(this.v.x, this.v.y);

        var boundingBoxes = this.world.boundingBoxes;
        var bx = this.world.bounds.x;
        var by = this.world.bounds.y;
        var x = this.p.x;
        var y = this.p.y;
        var vx = this.v.x;
        var vy = this.v.y;
    
        this.f.y += fGravity;

        //bounding box indexes
        var ibbxMax = numBoundingBoxesX-1;
        var ibbyMax = numBoundingBoxesY-1;
        var ibbx = clamp(Math.floor(ibbxMax*(x/bx)),0,ibbxMax);
        var ibby = clamp(Math.floor(ibbyMax*(y/by)),0,ibbyMax);
        var ibb = ibbx + ibby*numBoundingBoxesX;

        try {
            if(this.ibb!==ibb) {
                boundingBoxes[ibb].members.push(this);
                if(this.ibb!==null) {
                    //remove from prev box;
                    boundingBoxes[this.ibb].members.splice(boundingBoxes[this.ibb].members.indexOf(this), 1);
                }
            }
        } catch(e) {
            console.error('ibb=' + ibb);
            console.error('x' + x);
            console.error('y' + y);
        }
        

        //previous bounding box indexes
        this.ibbx = ibbx;
        this.ibby = ibby;
        this.ibb  = ibb;

        //this.color = boundingBoxes[ibb].color;
        var nibbxMax = Math.min(ibbxMax, ibbx+1);
        var nibbyMax = Math.min(ibbyMax, ibby+1);
        for(var nibbx = Math.max(0,ibbx-1); nibbx <= nibbxMax; nibbx++) {
            for(var nibby = Math.max(0,ibby-1); nibby <= nibbyMax; nibby++) {
                var nibb = nibbx + nibby*numBoundingBoxesX;
                var neighbours = boundingBoxes[nibb].members;
                for(var iP = 0; iP < neighbours.length; iP++) {
                    var particleB = neighbours[iP];
                    if(particleB!==this && particleB.updatedAt!==t) {
                        this.interact(particleB, dt);
                    }
                }
            }
        }


        //drag
        this.f.x -= cDrag*vx*Math.abs(vx);
        this.f.y -= cDrag*vy*Math.abs(vy);

        var x = this.p.x;
        var y = this.p.y;

        //boundary collisions
        var cx1 = bx - this.radius;
        var cx0 = 0  + this.radius;
        var cy1 = by - this.radius;
        var cy0 = 0  + this.radius;

        var ix1 = cx1 - this.radius;
        var ix0 = cx0 + this.radius;
        var iy1 = cy1 - this.radius;
        var iy0 = cy0 + this.radius;
        var w = 0;
        var force = 0;

        if (x > cx1) {
            x = cx1;
            //vx = -velocityBounceAttenuation*Math.abs(vx);
            vx = 0;
        } 
        if (x > ix1) {
            w = 1 - ((x-ix1) / this.radius);
            force = cFRepulsion*w;
            this.f.x -= force;
        }

        if (x < cx0) {
            x = cx0;
            //vx = velocityBounceAttenuation*Math.abs(vx);
            vx = 0;
        } 
        if (x < ix0) {
            w = 1 - ((ix0-x) / this.radius);
            force = cFRepulsion*w;
            this.f.x += force;
        }

        if (y > cy1) {
            y = cy1;
            //vy = -velocityBounceAttenuation*Math.abs(vy);
            vy = 0;
        } 
        if (y > iy1) {
            w = 1 - ((y-iy1) / this.radius);
            force = cFRepulsion*w;
            this.f.y -= force;
        }

        if (y < cy0) {
            y = cy0;
            //vy = velocityBounceAttenuation*Math.abs(vy);
            vy = 0;
        } 
        if (y < iy0) {
            w = 1 - ((iy0-y) / this.radius);
            force = cFRepulsion*w;
            this.f.y += force;
        }







        //acceleration
        var ax = this.f.x;
        var ay = this.f.y;
        
        vx += ax * dt;
        vy += ay * dt;

        x += vx * dt;
        y += vy * dt;




        this.p.x = x;
        this.p.y = y;
        this.v.x = vx;
        this.v.y = vy;

        this.updatedAt = t;
    }

    interact(particleB, dt) {
        var ax = this.p.x;
        var ay = this.p.y;
        var bx = particleB.p.x;
        var by = particleB.p.y;

        var avx = this.v.x;
        var avy = this.v.y;
        var bvx = particleB.v.x;
        var bvy = particleB.v.y;

        var deltaX = ax - bx;
        var deltaY = ay - by;
        var distSq = deltaX*deltaX + deltaY*deltaY;
        if(distSq>0) {
            var dist = Math.sqrt(distSq);
            var fUnitX = deltaX / dist;
            var fUnitY = deltaY / dist;
            var d0 = this.clipDistance;
            if(dist < d0) {
                var w = 1 - dist / d0;

                var force = cFRepulsion*w
                this.f.x += force*fUnitX;
                this.f.y += force*fUnitY;
                particleB.f.x -= force*fUnitX;
                particleB.f.y -= force*fUnitY;
                var deltaVx = this.v.x - particleB.v.x;
                var deltaVy = this.v.y - particleB.v.y;
                this.v.x -= deltaVx*cViscosity*dt;
                this.v.y -= deltaVy*cViscosity*dt;
                particleB.v.x += deltaVx*cViscosity*dt;
                particleB.v.y += deltaVy*cViscosity*dt;
            } 
        }
    }

    draw(context) {
        context.fillStyle = this.color;
        context.beginPath();
        context.moveTo(this.p.x, this.p.y);
        context.arc(this.p.x, this.p.y, this.radius, 0, Math.PI * 2, true);
        context.closePath();
        context.fill();
    }
}

function clamp(x, min, max) {
    return (x < min) ? min : ( (x > max) ? max : x );
}

export default WaterSimulationContainer;



// WEBPACK FOOTER //
// ./src/modules/misc/WaterSimulationContainer.js